// extracted by mini-css-extract-plugin
export default {"Btn":"styles_Btn__Igu32","desktop":"styles_desktop__0i2a4","mobile":"styles_mobile__FF-x6","error":"styles_error__Nllfq"};